

import { Grid } from "@mui/material";
import { useBuscadorGlobal } from "../../hooks/cache";
import { CargandoMedio, MensajeAlertaDanger } from "../components";
import { BuscadorXTermino } from "../components/buscadores";
import { LayoutCrearDoc } from "../layouts";
import { TablaDeOps } from "../op/components";
import { TablaListadoUsuarios } from "../superAdmin/components";





export const BuscadorGlobal = () => {


    const {termino, chageTermino, data, isLoading} = useBuscadorGlobal();



    return (
        <LayoutCrearDoc titulo='Buscador Global' add={false}>
            <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="op o usuario" playhol="nombre movil cedula" />

            {/* Estado: Cargando */}
            {(isLoading) &&
                <CargandoMedio titulo="Cargando información de búsqueda..." />
            }

            {/* Estado: No hay datos */}
            {!isLoading && 
                <>
                {((data?.usuarios?.length ?? 0) === 0 && (data?.ordenes?.length ?? 0) === 0) && 
                    <MensajeAlertaDanger titulo="Por favor, ingrese un término para realizar la búsqueda." />
                }

                <Grid container sx={{ mt: 2 }}>
                    <TablaListadoUsuarios data={data.usuarios} mostrar />
                </Grid>

                <Grid container sx={{ mt: 4 }}>
                    <TablaDeOps data={data.ordenes} mostrar />
                </Grid>
                </>
            }

        </LayoutCrearDoc>
    )
}
